import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class AxisAdd extends Component{
	render(){
		const {axis} =this.props;
		let ac = _.find(axis.permissions, (o) => {return o==='Create'});
		return (
			ac ?
				<p>
					<NavLink to={`/proigualdad/ejes/crear`} className="button is-small is-inm-purple">{'Agregar eje'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(AxisAdd);


// WEBPACK FOOTER //
// ./src/elements/axis/widget/axis_add.jsx